import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ShipToFilterParams, ShipTosSearchParams } from '../../../model';
import { normalizeHttpError } from '../../../util';
import { ShipTosConnector } from '../../connectors/ship-tos.connector';
import { UserActions } from '../actions';

@Injectable()
export class ShipTosEffects {
  loadUserShipTos$: Observable<UserActions.LoadUserShipTosSuccess | UserActions.LoadUserShipTosFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.LOAD_USER_SHIPTOS),
      switchMap((action: UserActions.LoadUserShipTos) => {
        const searchConfig = this.prepareSearchConifg(action.searchParams);
        return this.shipTosConnector.getShipTos(searchConfig, action.userId).pipe(
          map((res) => new UserActions.LoadUserShipTosSuccess(res, action.searchParams)),
          catchError((error) => of(new UserActions.LoadUserShipTosFail(action.searchParams, normalizeHttpError(error))))
        );
      })
    )
  );

  private prepareSearchConifg(searchParams: ShipTosSearchParams): ShipToFilterParams {
    return {
      currentPage: searchParams?.page,
      pageSize: searchParams?.count,
      search: searchParams?.text,
      onlyConnected: searchParams?.onlyConnected,
      soldTos: searchParams?.soldTos,
      connectedToPermissionCode: searchParams?.connectedToPermissionCode,
      permissionCode: searchParams?.permissionCode,
      sort: searchParams?.sort,
    };
  }

  constructor(private actions$: Actions, private shipTosConnector: ShipTosConnector) {}
}
